import { makeAutoObservable, runInAction } from 'mobx';

import {
  frontApi,
  API_ROUTES
} from '_app/api';
// import toast from 'utils/toast';

export class UsersStore {
  constructor() {
    makeAutoObservable(this);
  }

  isLoading = false;

  data = [];

  meta = {};

  errors = {};

  page = 1;

  perPage = 10;

  filters = {};

  fetchData = async (page, perPage) => {
    try {
      const { data: { items, meta } } = await frontApi(API_ROUTES.users.get, {
        params: {
          page: page || this.page,
          limit: perPage || this.perPage,
          ...this.filters,
        }
      });

      runInAction(() => {
        this.page = page;
        this.perPage = perPage;
        this.data = items;
        this.meta = meta;
      });

    } catch (error) {
      console.error(error);
    }
  };

  setFilters = (key, value) => {
    this.filters = {
      ...this.filters,
      [key]: value,
    }
  }

  removeFilter = (key) => {
    delete this.filters[key];

    this.fetchData();
  }

  clearAllFilters = () => {
    this.filters = {};

    this.fetchData();
  }

  saveRole = async (id, role) => {
    try {
      await frontApi.post(API_ROUTES.users.setRole, { id, role });

      this.fetchData();

      return null;
    } catch (error) {
      return error;
    }
  }

  ban = async (id) => {
    try {
      await frontApi.post(API_ROUTES.users.ban, { id, banInfo: { description: '' } });
      this.fetchData();

      return null;
    } catch (error) {
      return error;
    }
  }

  unBan = async (id) => {
    try {
      await frontApi.post(API_ROUTES.users.unBan, { id });
      this.fetchData();

      return null;
    } catch (error) {
      return error;
    }
  }
}

export default new UsersStore();
